class VisitsStorageApi {
  limit;
  storageApi;
  storageKeyPrefix = "@backstage/plugin-home:visits";
  identityApi;
  static create(options) {
    return new VisitsStorageApi(options);
  }
  constructor(options) {
    this.limit = Math.abs(options.limit ?? 100);
    this.storageApi = options.storageApi;
    this.identityApi = options.identityApi;
  }
  /**
   * Returns a list of visits through the visitsApi
   */
  async list(queryParams) {
    let visits = [...await this.retrieveAll()];
    (queryParams?.orderBy ?? []).reverse().forEach((order) => {
      if (order.direction === "asc") {
        visits.sort((a, b) => this.compare(order, a, b));
      } else {
        visits.sort((a, b) => this.compare(order, b, a));
      }
    });
    (queryParams?.filterBy ?? []).reverse().forEach((filter) => {
      visits = visits.filter((visit) => {
        const field = visit[filter.field];
        if (filter.operator === ">") return field > filter.value;
        if (filter.operator === ">=") return field >= filter.value;
        if (filter.operator === "<") return field < filter.value;
        if (filter.operator === "<=") return field <= filter.value;
        if (filter.operator === "==") return field === filter.value;
        if (filter.operator === "!=") return field !== filter.value;
        if (filter.operator === "contains")
          return `${field}`.includes(`${filter.value}`);
        return false;
      });
    });
    return visits;
  }
  /**
   * Saves a visit through the visitsApi
   */
  async save(saveParams) {
    const visits = [...await this.retrieveAll()];
    const visit = {
      ...saveParams.visit,
      id: window.crypto.randomUUID(),
      hits: 1,
      timestamp: Date.now()
    };
    const visitIndex = visits.findIndex((e) => e.pathname === visit.pathname);
    if (visitIndex >= 0) {
      visit.id = visits[visitIndex].id;
      visit.hits = visits[visitIndex].hits + 1;
      visits[visitIndex] = visit;
    } else {
      visits.push(visit);
    }
    visits.sort((a, b) => b.timestamp - a.timestamp);
    await this.persistAll(visits.splice(0, this.limit));
    return visit;
  }
  async persistAll(visits) {
    const storageKey = await this.getStorageKey();
    return this.storageApi.set(storageKey, visits);
  }
  async retrieveAll() {
    const storageKey = await this.getStorageKey();
    const snapshot = this.storageApi.snapshot(storageKey);
    if (snapshot?.presence !== "unknown") {
      return snapshot?.value ?? [];
    }
    return new Promise((resolve, reject) => {
      const subscription = this.storageApi.observe$(storageKey).subscribe({
        next: (next) => {
          const visits = next.value ?? [];
          subscription.unsubscribe();
          resolve(visits);
        },
        error: (err) => {
          subscription.unsubscribe();
          reject(err);
        }
      });
    });
  }
  async getStorageKey() {
    const { userEntityRef } = await this.identityApi.getBackstageIdentity();
    const storageKey = `${this.storageKeyPrefix}:${userEntityRef}`;
    return storageKey;
  }
  // This assumes Visit fields are either numbers or strings
  compare(order, a, b) {
    const isNumber = typeof a[order.field] === "number";
    return isNumber ? a[order.field] - b[order.field] : `${a[order.field]}`.localeCompare(`${b[order.field]}`);
  }
}

export { VisitsStorageApi };
//# sourceMappingURL=VisitsStorageApi.esm.js.map
